export default function WarningSignsSection() {
  const signs = [
    {
      icon: 'ri-user-settings-line',
      title: 'Mudança de Comportamento',
      description: 'Horários diferentes, novos hábitos, mudanças na rotina sem explicação clara.',
      color: 'red'
    },
    {
      icon: 'ri-heart-line',
      title: 'Distanciamento Emocional',
      description: 'Menos carinho, intimidade reduzida, conversas superficiais, frieza inexplicável.',
      color: 'orange'
    },
    {
      icon: 'ri-shirt-line',
      title: 'Vaidade Repentina',
      description: 'Roupas novas, perfume diferente, academia, cuidados com aparência sem motivo.',
      color: 'yellow'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Sigilo Digital',
      description: 'Celular sempre virado, senhas novas, conversas escondidas, redes sociais secretas.',
      color: 'green'
    },
    {
      icon: 'ri-question-line',
      title: 'Mentiras Inconsistentes',
      description: 'Versões diferentes da mesma história, desculpas que não fazem sentido.',
      color: 'blue'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Indícios Financeiros',
      description: 'Indícios financeiros observáveis no comportamento cotidiano.',
      color: 'purple'
    }
  ];

  const colorClasses = {
    red: 'bg-red-100 text-red-600',
    orange: 'bg-orange-100 text-orange-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    green: 'bg-green-100 text-green-600',
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600'
  };

  return (
    <section id="sinais" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            6 Sinais de Alerta Principais
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Reconheça os <strong>sinais mais comuns de infidelidade</strong>. 
            Se você identificou 3 ou mais, é hora de investigar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {signs.map((sign, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div className={`w-16 h-16 ${colorClasses[sign.color as keyof typeof colorClasses]} rounded-full flex items-center justify-center mb-4`}>
                <i className={`${sign.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {sign.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {sign.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-red-800 mb-2">
              ⚠️ Importante: Você Pode Estar Errado
            </h3>
            <p className="text-red-700">
              Esses sinais <strong>não são prova definitiva</strong> de traição. 
              Nossa investigação também serve para <strong>tranquilizar</strong> casais em relacionamentos saudáveis.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
